import React, { useState, useEffect } from "react";
import { Box, TextField, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import AddFacility from "./AddFacility";

function ViewFacility(props) {
  const [addFacility, setAddFacility] = useState(false);
  useEffect(() => {
    console.log("ViewUser props `values` updated:", props);
  }, [props]);
  console.log("props.handleEditprops.handleEdit", props.handleEdit);

  // const Edit =()=>{
  //   // setEdit(true);
  //   // props.setViewFacility(false)
  //   // setValueEdit(true);
  //   setAddFacility(true);
  //   setViewFacility(false);
  //   // props.setValues(false)
  // }

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "28rem",
        maxWidth: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      <AddFacility
        addFacility={addFacility}
        setAddFacility={setAddFacility}
        selectedFacility={props.selectedFacility}
      />
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => props.setViewFacility(false)}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          p: 3,
          width: "100%",
          backgroundColor: "#fff",
          height: "100%",
          overflow: "auto",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          Facility Details
        </Typography>
        <Box>
          <Box display="flex" gap={10}>
            <Box>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mt: 1 }}
              >
                Date
              </Typography>

              <p>
                {/* {props.selectedFacility?.createdAt.split('T')[0]??""} */}
                {new Date(props.selectedFacility?.createdAt).toLocaleDateString(
                  "en-GB",
                  { day: "2-digit", month: "2-digit", year: "numeric" }
                ) ?? ""}
              </p>
            </Box>
            <Box>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mt: 1 }}
              >
                Country
              </Typography>
              <p>{props.selectedFacility?.country ?? ""}</p>
            </Box>
          </Box>
        </Box>

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Name of Facility
        </Typography>
        <p>
          {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
          {props.selectedFacility?.facilityName ?? ""}
        </p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Contact Number
        </Typography>
        <p>
          {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
          {props.selectedFacility?.countryCode ?? ""}{" "}
          {props.selectedFacility?.phone ?? ""}
        </p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Email
        </Typography>
        <p>{props.selectedFacility?.email ?? ""}</p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Address
        </Typography>
        <p>{props.selectedFacility?.address ?? ""}</p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Nickname
        </Typography>
        <p>{props.selectedFacility?.nickname ?? ""}</p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Incharge
        </Typography>
        <p>{props.selectedFacility?.incharge ?? ""}</p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Outsource Facility
        </Typography>
        <p>{props.selectedFacility?.outsourceFacility ?? ""}</p>
        <Box>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={props.handleEdit}
          >
            Edit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            // This targets the paper component within the Drawer
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={props.viewFacility}
        onClose={() => props.setViewFacility(false)}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default ViewFacility;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
